const contractTSDMapConstant = {
  headerMapping: {
    Ratio: 'distribution_ratio',
  },
};

module.exports = { contractTSDMapConstant };
